/**
 * Shared PAGE_VIEW dedupe across Pixel instances (browser infra only).
 * Key: destinationName + destinationId + eventType + path/url + sessionId
 * Example: meta:877074838786597:PAGE_VIEW:/checkout:sess_abc
 */
const globalSeen = new Set<string>();

export function buildExternalPageViewKey(
  destinationName: string,
  destinationId: string,
  eventType: string,
  pathOrUrl: string,
  sessionId: string
): string {
  return `${destinationName}:${destinationId}:${eventType}:${pathOrUrl}:${sessionId}`;
}

export function shouldSkipExternalPageView(key: string): boolean {
  if (globalSeen.has(key)) return true;
  globalSeen.add(key);
  return false;
}

/** Test-only — clears shared dedupe state. */
export function clearExternalPageViewDeduper(): void {
  globalSeen.clear();
}

export function getExternalPageViewDeduperSize(): number {
  return globalSeen.size;
}

/** @deprecated Use module functions — kept for backward compatibility in tests. */
export class ExternalPageViewDeduper {
  buildKey(
    destinationName: string,
    destinationId: string,
    eventType: string,
    path: string,
    sessionId: string
  ): string {
    return buildExternalPageViewKey(
      destinationName,
      destinationId,
      eventType,
      path,
      sessionId
    );
  }

  shouldSkip(key: string): boolean {
    return shouldSkipExternalPageView(key);
  }

  clear(): void {
    clearExternalPageViewDeduper();
  }

  size(): number {
    return getExternalPageViewDeduperSize();
  }
}
